import {
  type GetShiftInviteResponse,
  GetShiftInviteResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";

import { SHIFT_INVITES_API_URL } from "../constant";

interface GetShiftInviteParams {
  shiftInviteId?: string;
}

export function useGetShiftInvite(
  params: GetShiftInviteParams,
  options?: UseGetQueryOptions<GetShiftInviteResponse>
): UseQueryResult<GetShiftInviteResponse> {
  const { shiftInviteId } = params;

  return useGetQuery({
    url: `${SHIFT_INVITES_API_URL}/${shiftInviteId}`,
    responseSchema: GetShiftInviteResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_SHIFT_INVITE_FAILURE,
    },
    ...options,
  });
}
